// AUTO-GENERATED by scripts/bump-version.js — não editar à mão.
// Reflete a data e o hash curto do commit no momento do build.
export const APP_VERSION = "v2026.10.13-dev";
